module.exports = __webpack_public_path__ + "img/document.c8fe6183.svg";